import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const QuestionMark = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M16 23C16 23.552 15.552 24 15 24C14.448 24 14 23.552 14 23C14 22.448 14.448 22 15 22C15.552 22 16 22.448 16 23Z" />
		<path d="M15 20C14.448 20 14 19.552 14 19C14 16.961 15.781 16 17.352 15.151C19 14.261 20 13.639 20 12.5C20 11.145 18.168 10 16 10C13.832 10 12 11.145 12 12.5V13C12 13.552 11.552 14 11 14C10.448 14 10 13.552 10 13V12.5C10 9.977 12.636 8 16 8C19.364 8 22 9.977 22 12.5C22 14.914 19.95 16.021 18.302 16.911C16.87 17.685 16 18.211 16 19C16 19.552 15.552 20 15 20Z" />
		<path d="M16 30C8.28 30 2 23.72 2 16C2 8.28 8.28 2 16 2C23.72 2 30 8.28 30 16C30 23.72 23.72 30 16 30ZM16 4C9.383 4 4 9.383 4 16C4 22.617 9.383 28 16 28C22.617 28 28 22.617 28 16C28 9.383 22.617 4 16 4Z" />
	</svg>
);

export default QuestionMark;
